import { render, staticRenderFns } from "./loginRegister.vue?vue&type=template&id=7618918f&"
import script from "./loginRegister.vue?vue&type=script&lang=js&"
export * from "./loginRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports